import React, { useEffect, useState } from "react";
import { FaHome, FaEnvelope, FaChartLine, FaBell, FaRocket } from "react-icons/fa";
import EmptyFeatureState from "../components/EmptyFeatureState";

export default function PropertyUpdate() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  return (
    <div style={{
      padding: isMobile ? "60px 16px 32px" : "32px 32px",
      flex: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      background: "#f6f8fa",
      boxSizing: "border-box",
      width: "100%",
      overflow: "auto",
    }}>
      <div style={{ maxWidth: 1100, marginLeft: "auto", marginRight: "auto", width: "100%", flex: 1, display: "flex", flexDirection: "column" }}>
        <h1 style={{ fontSize: isMobile ? 22 : 32, fontWeight: 700, margin: "0 0 4px 0", color: "#1f2937" }}>Property Updates</h1>
        <p style={{ color: "#6b7280", fontSize: 15, marginBottom: 28, lineHeight: 1.6 }}>
          Automated personalised emails sent to contacts who have a specific property address on file.
        </p>

        <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <EmptyFeatureState
          icon={<FaRocket />}
          title="Coming Soon"
          description="Property Update campaigns are being managed automatically for you. Soon you'll be able to customise templates, preview emails, and control send schedules right from this page."
          features={[
            { icon: <FaHome />, text: "Each contact receives a personalised update about their specific property — price estimates, comparable sales, and market movement" },
            { icon: <FaEnvelope />, text: "Emails are sent automatically on a schedule, keeping you top-of-mind with homeowners in your area" },
            { icon: <FaChartLine />, text: "Track delivery, opens, and clicks from your Dashboard to see which contacts are most engaged" },
            { icon: <FaBell />, text: "Get notified in real time when a contact opens their property update or clicks through to their report" },
          ]}
          examplePreview={
            <div style={{ padding: 16 }}>
              <div style={{
                background: "#fff", borderRadius: 10, border: "1px solid #e5e7eb",
                padding: 20, maxWidth: 400, margin: "0 auto",
              }}>
                <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 8 }}>PROPERTY UPDATE EMAIL</div>
                <div style={{ fontSize: 15, fontWeight: 700, color: "#1f2937", marginBottom: 4 }}>42 Ocean View Drive, Coogee</div>
                <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 12 }}>Hi Sarah, here's the latest on your property...</div>
                <div style={{
                  display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8,
                }}>
                  {[
                    { label: "Estimated Value", val: "$2.35M" },
                    { label: "Change (12mo)", val: "+6.2%" },
                    { label: "Recent Sales Nearby", val: "8" },
                    { label: "Median Days on Market", val: "28" },
                  ].map(s => (
                    <div key={s.label} style={{
                      background: "#f8fafc", borderRadius: 8, padding: "10px 12px",
                      border: "1px solid #f3f4f6",
                    }}>
                      <div style={{ fontSize: 10, color: "#9ca3af" }}>{s.label}</div>
                      <div style={{ fontSize: 15, fontWeight: 700, color: "#1f2937" }}>{s.val}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          }
          isMobile={isMobile}
        />
        </div>
      </div>
    </div>
  );
}
